<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/obhy6J/tc-custom/9781480484306.jpg?1698164768486" alt="This image is the cover for the book Bound to Happen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bound to Happen
      </h1>
      <p class="bookDescription body article font2">
        <b>A novel that asks the age-old question, <i>Does true love really exist?</i> </b><br/><br/>Leslie Rothe wants to believe in love. But the data research analyst has just about given up on finding the One. Her life changes the day she crashes her car into a stranger’s truck. Suddenly, Leslie is stranded in the Rocky Mountains with a man who awakens treacherous desire within her—and there is no hope of rescue in sight.  <br/><br/>Joe Bonner loves the mountains, and will do everything in his power to preserve his Western ancestors’ sacred legacy. Now he has found a woman who shares his passion for the land. But he soon discovers that Leslie works for a developer who is out to destroy the pristine wilderness that Joe is fighting so hard to save. Has he given his trust to a woman fated to betray him? Or has he found a love that transcends differences—a love to have and to hold in his heart forever?<br/><br/>This ebook features an extended biography of Mary Kay McComas.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Kay McComas
      </h2>
      
      <p class="authorDescription body article">Mary Kay McComas is an acclaimed romance novelist and the author of twenty-one short contemporary romances, five novellas, and two novels. McComas has received numerous honors and prizes for her work, including the Washington Romance Writers&rsquo; Outstanding Achievement Award and two Career Achievement Awards from <i>Romantic Times</i> (one for Best New Novel and another for Most Innovative Romance Series). She has recently contributed to Nora Roberts&rsquo;s J. D. Robb fantasy anthologies, with highly praised paranormal romance stories. McComas and her family live in Virginia&rsquo;s Shenandoah Valley.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?294330ad